import { type MutationOptions, QueryClient, type QueryClientConfig } from "@tanstack/react-query";

export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10,
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: process.env.NODE_ENV === "production",
      refetchOnReconnect: true,
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
};

export function createQueryClient(): QueryClient {
  return new QueryClient(queryClientConfig);
}

export function executeMutation<TData, TError = Error, TContext = unknown>(
  queryClient: QueryClient,
  mutationOptions: MutationOptions<TData, TError, void, TContext>,
): Promise<TData>;
export function executeMutation<TData, TVariables, TError = Error, TContext = unknown>(
  queryClient: QueryClient,
  mutationOptions: MutationOptions<TData, TError, TVariables, TContext>,
  variables: TVariables,
): Promise<TData>;
export function executeMutation<TData, TVariables, TError = Error, TContext = unknown>(
  queryClient: QueryClient,
  mutationOptions: MutationOptions<TData, TError, TVariables, TContext>,
  variables?: TVariables,
): Promise<TData> {
  return queryClient
    .getMutationCache()
    .build(queryClient, mutationOptions)
    .execute(variables as TVariables);
}
